(function () {
  'use strict';

  if (customElements.get('crest-drawer-upsell')) return;

  function message(drawer, text) {
    const inner = drawer.querySelector('.drawer__inner');
    let notice = inner.querySelector('.crest-drawer__notice');

    if (!notice) {
      notice = document.createElement('p');
      notice.className = 'crest-drawer__notice';
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');
      inner.querySelector('.drawer__header').after(notice);
    }

    notice.textContent = text;
  }

  function lock(drawer, busy) {
    if (busy) {
      drawer.dataset.crestUpsellBusy = 'true';
    } else {
      delete drawer.dataset.crestUpsellBusy;
    }

    drawer.querySelectorAll(
      'cart-drawer-items, .drawer__footer, crest-drawer-upsell'
    ).forEach(node => {
      node.inert =
        busy || drawer.dataset.crestCartRefreshing === 'true';
    });
  }

  async function readCart() {
    const response = await fetch(
      (window.Shopify?.routes?.root || '/') + 'cart.js',
      {
        credentials: 'same-origin',
        cache: 'no-store'
      }
    );

    if (!response.ok) {
      throw new Error(
        'Impossibile verificare il carrello. Riprova.'
      );
    }

    const cart = await response.json();

    if (
      !Array.isArray(cart.items) ||
      !Number.isFinite(cart.item_count)
    ) {
      throw new Error(
        'Impossibile verificare il carrello. Riprova.'
      );
    }

    return cart;
  }

  async function render(drawer, result) {
    if (
      typeof result?.sections?.['cart-drawer'] === 'string' &&
      result.sections['cart-drawer'].trim()
    ) {
      drawer.renderContents(result, { open: false });
      return;
    }

    const url = new URL(
      (window.Shopify?.routes?.root || '/') + 'cart',
      location.origin
    );

    url.searchParams.set(
      'sections',
      'cart-drawer,cart-icon-bubble'
    );

    const response = await fetch(url.href, {
      credentials: 'same-origin',
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error(
        'Aggiorna il carrello per visualizzare il contenuto attuale.'
      );
    }

    drawer.renderContents(
      { sections: await response.json() },
      { open: false }
    );
  }

  function notify(drawer, cart) {
    if (!cart) return;

    if (
      typeof publish === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined'
    ) {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'cart-items',
        sourceElement: drawer.querySelector('cart-drawer-items'),
        cartData: cart
      });
    }

    document.dispatchEvent(
      new CustomEvent('crest-pairings:cart-changed', {
        detail: { cart }
      })
    );
  }

  customElements.define(
    'crest-drawer-upsell',
    class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;

        this.addEventListener('click', event => {
          const pill = event.target.closest(
            '[data-upsell-variant]'
          );

          if (!pill || pill.disabled) return;

          const form = pill.closest('form');

          form.querySelector('[name="id"]').value =
            pill.dataset.upsellVariant;

          form.querySelector('[data-upsell-price]').textContent =
            pill.dataset.money;

          form.querySelectorAll(
            '[data-upsell-variant]'
          ).forEach(button => {
            button.setAttribute(
              'aria-pressed',
              String(button === pill)
            );
          });
        });

        this.addEventListener('change', event => {
          if (
            !event.target.matches('[data-upsell-select]')
          ) return;

          const select = event.target;

          select.form.querySelector(
            '[data-upsell-price]'
          ).textContent =
            select.selectedOptions[0].dataset.money;
        });

        this.addEventListener('submit', event => {
          const form = event.target.closest(
            '.crest-upsell__form'
          );

          if (!form) return;

          event.preventDefault();
          event.stopPropagation();

          this.addProduct(form);
        });
      }

      async addProduct(form) {
        const drawer = this.closest('cart-drawer');

        if (
          !drawer ||
          drawer.dataset.crestUpsellBusy === 'true'
        ) return;

        const engine =
          typeof CartItems !== 'undefined'
            ? CartItems
            : null;

        if (
          !engine ||
          typeof drawer.renderContents !== 'function'
        ) {
          message(
            drawer,
            'Apri la scheda del prodotto per completare la scelta.'
          );
          return;
        }

        const id = form.querySelector('[name="id"]').value;
        const productId = form.dataset.productId;
        const button = form.querySelector('[type="submit"]');
        const previousRefresh = drawer.refreshPromise;
        const previousQueue =
          engine.mutationQueue || Promise.resolve();

        let added = false;
        let outcome = '';
        let currentCart = null;

        lock(drawer, true);
        button.textContent = 'Aggiungo…';

        const operation = Promise.allSettled([
          previousQueue,
          previousRefresh
        ]).then(async () => {
          lock(drawer, true);

          const latest = await readCart();

          if (
            latest.items.some(
              item => String(item.product_id) === productId
            )
          ) {
            await render(drawer);
            currentCart = latest;
            outcome = 'Questo prodotto è già nel carrello.';
            return;
          }

          engine.invalidateCartView();

          let result;
          let addError;
          let rejected = false;

          try {
            const response = await fetch(
              (window.Shopify?.routes?.root || '/') +
                'cart/add.js',
              {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: JSON.stringify({
                  items: [{ id, quantity: 1 }],
                  sections: [
                    'cart-drawer',
                    'cart-icon-bubble'
                  ],
                  sections_url: location.pathname
                })
              }
            );

            result = await response.json();

            if (!response.ok || result.status) {
              rejected = true;

              throw new Error(
                typeof result.description === 'string'
                  ? result.description
                  : 'Prodotto non disponibile nella quantità richiesta.'
              );
            }

            added = true;
          } catch (error) {
            addError = error;
          }

          engine.invalidateCartView();

          try {
            currentCart = await readCart();
          } catch (_) {}

          try {
            await render(
              drawer,
              added ? result : null
            );
          } catch (error) {
            outcome = added
              ? 'Prodotto aggiunto. Riapri il carrello per aggiornare il riepilogo.'
              : 'Verifica il carrello prima di riprovare: non posso confermare l’esito dell’aggiunta.';
            return;
          }

          outcome = added
            ? 'Prodotto aggiunto al carrello.'
            : (
                rejected
                  ? addError.message
                  : 'Verifica il carrello prima di riprovare: non posso confermare l’esito dell’aggiunta.'
              );
        });

        engine.mutationQueue = operation.catch(() => {});

        try {
          await operation;
        } catch (error) {
          outcome =
            error.message ||
            'Impossibile completare l’aggiunta. Riprova.';
        } finally {
          lock(drawer, false);

          if (button.isConnected) {
            button.textContent = '+ Aggiungi';
          }

          try {
            notify(drawer, currentCart);
          } catch (error) {
            console.warn(
              'CREST: aggiornamento componenti',
              error
            );
          }

          if (outcome) message(drawer, outcome);

          if (
            typeof drawer.focusContents === 'function'
          ) {
            drawer.focusContents();
          }
        }
      }
    }
  );
})();